import React from 'react';
import { TrendingDownIcon, LockIcon, EyeOffIcon, ShieldIcon } from 'lucide-react';
const features = [{
  icon: TrendingDownIcon,
  title: 'Best Exchange Rates',
  description: 'Lock in competitive exchange rates and save money on every international transaction. No hidden fees, no surprises.'
}, {
  icon: LockIcon,
  title: 'Worldwide Travel Integrations',
  description: 'Integrated with direct rate providers to ensure a smooth end to end booking experience.'
}, {
  icon: EyeOffIcon,
  title: 'Privacy Protection',
  description: 'We never share your card details directly with merchants. Your sensitive information stays protected at all times.'
}, {
  icon: ShieldIcon,
  title: 'Enhanced Payment Protection',
  description: 'Advanced fraud detection and payment protection ensure your transactions are safe and secure, giving you peace of mind.'
}];
export function Features() {
  return <div className="w-full px-6 py-24 bg-slate-50" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-37">
            Why Choose Pomelo Services?
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-38">
            Comprehensive protection and reliability to run international travel
            operations.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-39">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="bg-white p-8 rounded-2xl border border-slate-200 hover:border-blue-200 hover:shadow-lg transition-all duration-200" data-id="element-40">
                <div className="w-12 h-12 rounded-xl bg-blue-600 flex items-center justify-center mb-6" data-id="element-41">
                  <Icon className="w-6 h-6 text-white" data-id="element-42" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-43">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-44">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </div>;
}